import React, { useState } from 'react'
import FreeTrialForm from '@/components/FreeTrialForm'
import LoadingCalu from '@/components/LoadingCalu'
import NavBar from '@/components/NavBar'

import HeroAside from './components/HeroAside'
import SplitLayout from './components/SplitLayout'

import s from './styles.module.scss'

const FreeTrialPage = () => {
  const [isLoadingCalu, setIsLoadingCalu] = useState(false)
  return (
    <div className={s.container}>
      <NavBar />
      <main className={s.main}>
        {!isLoadingCalu ? (
          <SplitLayout left={<HeroAside />} right={<FreeTrialForm setIsLoadingCalu={setIsLoadingCalu} />} />
        ) : (
          <LoadingCalu />
        )}
      </main>
    </div>
  )
}

export default FreeTrialPage
